import { type Draft, produce } from "immer";

export const ImmutableSetOperations = {
    add: <T>(set: ReadonlySet<T>, item: T): ReadonlySet<T> => {
        return produce(set, (draft: Set<Draft<T>>): void => {
            void draft.add(item as Draft<T>);
        });
    },

    delete: <T>(set: ReadonlySet<T>, item: T): ReadonlySet<T> => {
        return produce(set, (draft: Set<Draft<T>>): void => {
            draft.delete(item as Draft<T>);
        });
    },
};
